const APPS_REVIEW_BUTTON_SELECTOR = '.section--apps [data-section-type="section_apps"] .yotpo-new-review-btn';

function forceAppsReviewButtonLabel(root = document) {
  root.querySelectorAll(APPS_REVIEW_BUTTON_SELECTOR).forEach((button) => {
    if (button.textContent.trim() === '+ Add a review') return;
    button.textContent = '+ Add a review';
  });
}

function hasOpenOverlayState() {
  const drawerRoot = document.querySelector('#Details-menu-drawer-container');
  const isMenuDrawerOpen =
    drawerRoot && (drawerRoot.hasAttribute('open') || drawerRoot.classList.contains('menu-opening'));
  const isCartDrawerOpen = !!document.querySelector('cart-drawer.active');
  const isModalOpen = !!document.querySelector('modal-dialog[open], details-modal[open]');
  const isLocalizationOpen = !!document.querySelector('localization-form .disclosure__list-wrapper:not([hidden])');
  const isCountrySelectorOpen = !!document.querySelector('.menu-drawer.country-selector-open');

  return isMenuDrawerOpen || isCartDrawerOpen || isModalOpen || isLocalizationOpen || isCountrySelectorOpen;
}

function releaseScrollLocksIfSafe() {
  if (hasOpenOverlayState()) return;

  document.body.classList.remove(
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop',
    'overflow-hidden'
  );
  document.documentElement.classList.remove('menu-drawer-scroll-lock');
}

releaseScrollLocksIfSafe();
document.addEventListener('DOMContentLoaded', releaseScrollLocksIfSafe);
window.addEventListener('load', releaseScrollLocksIfSafe);
window.addEventListener('pageshow', releaseScrollLocksIfSafe);
document.addEventListener('DOMContentLoaded', () => forceAppsReviewButtonLabel());
window.addEventListener('load', () => forceAppsReviewButtonLabel());

const appsReviewButtonObserver = new MutationObserver(() => {
  forceAppsReviewButtonLabel();
});

appsReviewButtonObserver.observe(document.body, {
  childList: true,
  subtree: true
});

let startupScrollUnlockAttempts = 0;
const startupScrollUnlockTimer = window.setInterval(() => {
  startupScrollUnlockAttempts += 1;
  releaseScrollLocksIfSafe();
  forceAppsReviewButtonLabel();
  if (startupScrollUnlockAttempts >= 10) {
    window.clearInterval(startupScrollUnlockTimer);
  }
}, 400);
